export const getLegacyMyListItems = (inputList: string[] = [], videos?: any[]) => {
  if (!inputList.length) return [];
  if (!videos?.length) return null;
  return videos.filter((video) => inputList.includes(video.id));
};

export const mapRecommendationsByRequestedIds = (
  recommendationIds: string[],
  recommendationItems: any[],
  recommendationMap: Map<string, { videoId: string; seriesId: string; confidence: number; index: number }>
) => {
  const recommendationItemsById = new Map(recommendationItems.map((video) => [video.id, video]));
  return recommendationIds
    .map((videoId) => {
      const video = recommendationItemsById.get(videoId);
      const recommendation = recommendationMap.get(videoId);
      if (!video || !recommendation) return null;
      return {
        ...video,
        seriesId: recommendation.seriesId,
        confidence: recommendation.confidence,
        index: recommendation.index,
        recommended: true,
      };
    })
    .filter(Boolean);
};
